module.exports = __webpack_public_path__ + "static/img/051.f7b25c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/051.png
// module id = YzLy
// module chunks = 0